'use client';

import { MaterialSymbol } from '@florencelabs/icons';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearch } from '@provider-directory/contexts/ProviderSearchContext';

export const SoftMatchesBanner = (): ReactElement => {
  const { t } = useTranslation();
  const { clearFiltersKeepScope } = useSearch();

  return (
    <div
      role={'status'}
      data-testid={'soft-matches-banner'}
      className={
        'mb-4 flex flex-col items-start gap-4 rounded-lg bg-primary-200 p-6 tablet:flex-row tablet:items-center tablet:justify-between'
      }
    >
      <div
        className={
          'flex min-w-0 flex-col items-start gap-4 tablet:flex-row tablet:gap-3'
        }
      >
        <MaterialSymbol
          name={'error_fill'}
          size={20}
          aria-hidden={'true'}
          className={'shrink-0 text-primary-900 tablet:mt-0.5'}
        />
        <div className={'min-w-0'}>
          <p className={'text-body-medium-semibold'}>
            {t('searchResults.softMatchesBannerTitle')}
          </p>
          <p className={'text-body-medium'}>
            {t('searchResults.softMatchesBannerBody')}
          </p>
        </div>
      </div>
      <button
        type={'button'}
        className={'shrink-0 text-body-medium'}
        onClick={() => {
          clearFiltersKeepScope();
        }}
      >
        {t('searchFilters.clear')}
      </button>
    </div>
  );
};

export const OtherSchedulingOptionsSeparator = (): ReactElement => {
  const { t } = useTranslation();

  return (
    <div
      data-testid={'other-scheduling-options-separator'}
      className={'my-6 flex items-center gap-4'}
    >
      <div aria-hidden={'true'} className={'h-px flex-1 bg-black/16'} />
      <h3 className={'text-body-medium font-semibold text-neutral-950'}>
        {t('searchResults.otherSchedulingOptions')}
      </h3>
      <div aria-hidden={'true'} className={'h-px flex-1 bg-black/16'} />
    </div>
  );
};
